const fonts = {
    core: {
        "1": "TT Travels",
        "2": "Noto Sans",
        "3": "Verdana",
        default: "TT Travels",
    },
};
export default fonts;
//# sourceMappingURL=fonts.js.map